// extracted by mini-css-extract-plugin
export default {"content":"PostContent_content__uaBDe","linkPost":"PostContent_linkPost__N2nbn","linkAuthor":"PostContent_linkAuthor__ro+BX"};